import { jsx as _jsx } from "react/jsx-runtime";
import { BadImplementationException, logicalXOR, MUSTNeverHappenException, resolveContent } from '@nu-art/ts-common';
import { ComponentSync, dispatcher_urlParamsChanged, ModuleFE_BrowserHistory, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend';
import { TS_Workspace } from '@nu-art/ts-workspace-frontend';
import './Page_BaseManagerUI.scss';
export const ManagerUI_ItemId = 'id';
export const ManagerUI_ItemType = 'type';
export class Page_BaseManagerUI extends ComponentSync {
    __onLocationChanged = (path) => {
        this.reDeriveState();
    };
    onSearchResultSelected = (selectedResultId, entityType, state) => {
        const searchItem = this.props.searchItems.find(searchItem => searchItem.type === entityType);
        if (!searchItem)
            throw new MUSTNeverHappenException(`Cannot find search item with entity type: ${entityType}`);
        const selectedResult = searchItem.module.cache.unique(selectedResultId);
        if (!selectedResult)
            throw new BadImplementationException(`Could not find item for selectedResultId ${selectedResultId} and entity type: ${entityType}`);
        // this.logInfo(`search reached end and setting params`);
        ModuleFE_BrowserHistory.setQuery({ [ManagerUI_ItemId]: selectedResultId, [ManagerUI_ItemType]: entityType });
        dispatcher_urlParamsChanged.dispatchUI();
        this.reDeriveState(state);
    };
    deriveStateFromProps(nextProps, state) {
        const id = ModuleFE_BrowserHistory.getQueryParameter(ManagerUI_ItemId);
        const type = ModuleFE_BrowserHistory.getQueryParameter(ManagerUI_ItemType);
        if (logicalXOR(!!id, !!type))
            this.clearSelectedResult();
        if (id && type)
            state.selectedResult = { id, type };
        return state;
    }
    clearSelectedResult() {
        ModuleFE_BrowserHistory.removeQueryParam(ManagerUI_ItemId);
        ModuleFE_BrowserHistory.removeQueryParam(ManagerUI_ItemType);
        dispatcher_urlParamsChanged.dispatchUI();
    }
    render() {
        const workspace = resolveContent(this.workspace);
        return _jsx(TS_ErrorBoundary, { children: _jsx(TS_Workspace, { id: workspace.id, className: 'quai-manager-ui', workspaceKey: workspace.key, renderers: workspace.renderers, instances: { ...workspace.instances } }) });
    }
}
//# sourceMappingURL=Page_BaseManagerUI.js.map